import React from "react";
import { IMG } from "@/lib/images";

// The BSN emblem — same rectangular seal image used on the Home page.
export const BsnSeal = ({ size = 72, className = "", withText = false }) => (
  <div className={`inline-flex items-center gap-3 ${className}`} data-testid="bsn-seal">
    <img
      src={IMG.seal}
      alt="Bright Stories Network seal"
      style={{ width: size, height: size }}
      className="rounded-md object-cover ring-1 ring-bsn-gold/50 shadow-md shrink-0"
    />
    {withText && (
      <span className="flex flex-col leading-none">
        <span className="font-display text-[15px] sm:text-base font-semibold tracking-[0.18em] gold-text">
          BRIGHT STORIES
        </span>
        <span className="font-display text-[15px] sm:text-base font-semibold tracking-[0.34em] text-bsn-ice/90">
          NETWORK
        </span>
      </span>
    )}
  </div>
);
